<template src="./navigation.html"></template>

<script>

export default {
  data() {
    return {
      display: true,
      isActive: {
        home: false,
        action: false,
        service: false,
        company: false,
        question: false,
        contact: false,
        job: false,
        school: false,
      },
    };
  },

  methods: {
    changeLanguage(lang) {
      if (lang === 'ja' || lang === 'en') {
        localStorage.setItem('lang', lang);
        this.$i18n.locale = lang;
      }
      window.location.reload();
      this.currentRouteName();
    },
    reset() {
      this.isActive.home = false;
      this.isActive.action = false;
      this.isActive.service = false;
      this.isActive.company = false;
      this.isActive.question = false;
      this.isActive.contact = false;
      this.isActive.job = false;
      this.isActive.school = false;
    },
    isClick() {
      switch (this.$route.name) {
        case 'home':
          this.reset();
          this.isActive.home = true;
          break;
        case 'news.list':
          this.reset();
          this.isActive.action = true;
          break;
        case 'itemService':
          this.reset();
          this.isActive.service = true;
          break;
        case 'about-us':
          this.reset();
          this.isActive.company = true;
          break;
        case 'question.list':
          this.reset();
          this.isActive.question = true;
          break;
        case 'contact':
          this.reset();
          this.isActive.contact = true;
          break;
        case 'job.list':
          this.reset();
          this.isActive.job = true;
          break;
        case 'schools.list':
          this.reset();
          this.isActive.school = true;
          break;
        default:
          this.reset();
          this.isActive.home = true;
      }
    },
    currentRouteName() {
      if (this.$route.name === 'home') {
        this.isActive.home = true;
      }
      switch (this.$route.name) {
        case 'home':
          this.isActive.home = true;
          break;
        case 'news.list':
          this.isActive.action = true;
          break;
        case 'itemService':
          this.isActive.service = true;
          break;
        case 'about-us':
          this.isActive.company = true;
          break;
        case 'question.list':
          this.isActive.question = true;
          break;
        case 'contact':
          this.isActive.contact = true;
          break;
        case 'job.list':
          this.isActive.job = true;
          break;
        case 'schools.list':
          this.isActive.school = true;
          break;
        default:
          this.isActive.home = true;
      }
    },
  },
  created() {
    this.currentRouteName();
  },
  watch: {
    $route(to, from) {
      if (to.name === 'home') {
        this.reset();
        this.isActive.home = true;
      }
      if (to.name === 'news.list') {
        this.reset();
        this.isActive.action = true;
      }
      if (to.name === 'itemService' || to.name === 'contentService') {
        this.reset();
        this.isActive.service = true;
      }
      if (to.name === 'about-us') {
        this.reset();
        this.isActive.company = true;
      }
      if (to.name === 'question.list') {
        this.reset();
        this.isActive.question = true;
      }
      if (to.name === 'contact') {
        this.reset();
        this.isActive.contact = true;
      }
      if (to.name === 'job.list' || to.name === 'job.search') {
        this.reset();
        this.isActive.job = true;
      }
      if (to.name === 'schools.list' || to.name === 'schools.item') {
        this.reset();
        this.isActive.school = true;
      }

      if (to.name === 'top.show' || to.name === 'news.show' || to.name === 'job.show' || to.name === 'schools.show'
      ) {
        this.display = false;
      } else {
        this.display = true;
      }

      if (from.name === 'home') {
        const changeRoute = to.name;
        switch (changeRoute) {
          case 'news.list':
          case 'news.show':
            this.reset();
            this.isActive.action = true;
            break;
          case 'schools.list':
          case 'schools.show':
            this.reset();
            this.isActive.school = true;
            break;
          default:
        }
      }
    },
  },
};
</script>
<style scoped>
.image_icon {
  width: 25px;
  height: 15px;
  margin-left: 5px;
}
.mainmenu ul li a:hover {
  display: initial;
  text-transform: uppercase;
  font-size: 17px;
  position: relative;
  background: linear-gradient(50deg, rgba(158, 57, 111, 0.98) 0%, rgba(63, 46, 47, 0.32) 100%);
  height: 100%;
}
.mainmenu ul li a.active {
  display: initial;
  text-transform: uppercase;
  font-size: 17px;
  position: relative;
  background: linear-gradient(50deg, rgba(158, 57, 111, 0.98) 0%, rgba(63, 46, 47, 0.32) 100%);
  height: 100%;
}
</style>
